/* eslint-disable max-len */
import React, {
    useContext,
    useEffect,
} from 'react';

import {
    Box,
    Flex,
    VStack,
    Image,
    Spacer,
    Text,
    OrderedList,
    ListItem,
    ListIcon,
    List,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

import { ToastBoxContext } from '../../contexts/ToastBoxContext';

// images path
import brainstormAndDiscussionPath from '../../resources/brainstormAndDiscussion.png';

import PageTitle from '../../components/PageTitle';

function Capture() {
    const {
        toast,
        onCloseToast,
    } = useContext(ToastBoxContext);

    // close toast message if open
    useEffect(
        () => {
            if (toast) {
                onCloseToast();
            }
        },
        [onCloseToast, toast],
    );

    return (
        <VStack
            align="stretch"
            spacing={4}
            role="main"
        >
            <PageTitle
                title="Capture: Brainstorm & Discussion"
            />
            <Flex
                borderWidth={1}
                width="100%"
                padding={8}
                marginBottom={1}
            >
                <Box width="50%">
                    <Text fontSize={18} fontWeight="bold">
                        Instructions:
                    </Text>

                    <OrderedList
                        paddingX={4}
                        paddingY={2}
                        width="100%"
                    >
                        <ListItem p={2}>
                            Listen to / read the question
                        </ListItem>
                        <ListItem p={2}>
                            Write down the first effects that come to mind in your notes sheets (1 minute)
                            <List
                                paddingX={4}
                                paddingY={2}
                            >
                                <ListItem p={2}>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    Consider effects of any “fact” of the product / service
                                </ListItem>
                                <ListItem p={2}>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    Functionality, characteristic, organization, business
                                </ListItem>
                            </List>
                        </ListItem>
                        <ListItem p={2}>
                            Discuss all the ideas within the team (5 minutes max.)
                            <List
                                paddingX={4}
                                paddingY={2}
                            >
                                <ListItem p={2}>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    Decide with effects are worth capturing
                                </ListItem>
                                <ListItem p={2}>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    Write positive effects on green and negative on orange cards
                                    (with ‘fact’, if it was mentioned)
                                </ListItem>
                                <ListItem p={2}>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    Paste in likelihood & impact matrix
                                </ListItem>
                            </List>
                        </ListItem>
                    </OrderedList>
                </Box>
                <Spacer />
                <Image
                    src={brainstormAndDiscussionPath}
                    alt="logo"
                    role="img"
                    width="40%"
                />
            </Flex>
        </VStack>
    );
}

export default Capture;
